import { fromJS } from 'immutable';
import Segment from '../../helpers/segment';
import { ProfileActionTypes } from './actions';
import { createReducer } from '../../helpers/store';

const initialState = fromJS({
  errors: '',
  isLoading: true,
  profile: {
    first_name: '',
    last_name: '',
    email: '',
    street_1: '',
    street_2: '',
    city: '',
    state: '',
    zipcode: ''
  }
});

/**
 * Called when get profile request is initiated.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleGetProfileRequest = (state, action) => {
  Segment.track('Getting profile');
  return state.set('isLoading', true).set('errors', '');
};

/**
 * Called when the get profile request fails.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleGetProfileFailure = (state, action) => {
  Segment.track('Failed to get profile', { error: action.data.error });
  return state
    .set('isLoading', false)
    .set(
      'errors',
      action.data.error || 'Sorry, we were unable to load your profile.'
    );
};

/**
 * Called when get profile request is successful.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleGetProfileSuccess = (state, action) => {
  Segment.track('Got profile');
  return state
    .set('errors', '')
    .set('profile', fromJS(action.response.data))
    .set('isLoading', false);
};

/**
 * Called when update profile request is initiated.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleUpdateProfileRequest = (state, action) => {
  Segment.track('Updating profile');
  return state.set('errors', '');
};

/**
 * Called when the update profile request fails.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleUpdateProfileFailure = (state, action) => {
  Segment.track('Failed to update profile', { error: action.data.error });
  return state.set(
    'errors',
    action.data.error || 'Sorry, we were unable to update your profile.'
  );
};

/**
 * Called when update profile request is successful.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleUpdateProfileSuccess = (state, action) => {
  Segment.track('Updated profile');
  return state.set('errors', '').set('showModal', false);
};

export const profileReducer = createReducer(initialState, {
  [ProfileActionTypes.GET_PROFILE_REQUEST]: handleGetProfileRequest,
  [ProfileActionTypes.GET_PROFILE_SUCCESS]: handleGetProfileSuccess,
  [ProfileActionTypes.GET_PROFILE_FAILURE]: handleGetProfileFailure,

  [ProfileActionTypes.UPDATE_PROFILE_REQUEST]: handleUpdateProfileRequest,
  [ProfileActionTypes.UPDATE_PROFILE_SUCCESS]: handleUpdateProfileSuccess,
  [ProfileActionTypes.UPDATE_PROFILE_FAILURE]: handleUpdateProfileFailure
});



/** WEBPACK FOOTER **
 ** ./src/state/profile/reducer.js
 **/